import { Component, Input, OnInit, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { CdkStep } from '@angular/cdk/stepper';
import { CdkStepper } from '@angular/cdk/stepper';

@Component({
    selector: '[customCdkStep]',
    template: '<ng-template><ng-content></ng-content></ng-template>',
    providers: [{ provide: CdkStep, useExisting: CdkStepDirective }],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CdkStepDirective extends CdkStep{

	@Input() public computedStep: any;

	// CDK 22: CdkStep risolve lo stepper con inject(), super() senza argomenti
	constructor(){
		super();
	}
}
